import DynamicField from "./DynamicField";
import { isFieldVisible } from "../utils/formSchema";

// uploadsLast moves image/document fields below the rest of the form (stable
// otherwise), e.g. the NOA / Contract Signing uploads.
export default function DynamicFieldGrid({ fields, values, onChange, errors, configOptions, readOnly, onUpload, showRequired, uploadsLast }) {
  let shown = fields.filter((f) => isFieldVisible(f, values));
  if (uploadsLast) shown = [...shown.filter((f) => f.type !== "image"), ...shown.filter((f) => f.type === "image")];
  return (
    <div className="field-grid">
      {shown.map((f) => (
        <DynamicField
          key={f.id + f.name}
          field={f}
          value={values[f.name]}
          values={values}
          onChange={onChange}
          error={errors && errors[f.name]}
          configOptions={configOptions}
          readOnly={readOnly}
          onUpload={onUpload}
          showRequired={showRequired}
        />
      ))}
    </div>
  );
}
